import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { toast } from 'react-toastify';
import { CommonDeathplaceCrumbs } from 'civil-status/constants/place';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormPlace from 'civil-status/components/place/form';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformRequest } from 'civil-status/utils/place';
import { DomainType } from 'civil-status/constants/domain';

const DeathplaceNewPage = (): React.ReactElement => {
  const insertDeathplace = useHttpClient(`${__ACT_API_URL__}/valori-dominio-atti/insert`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: PlaceForm) => {
      const data = transformRequest(formValues, DomainType.Deathplace);

      (
        insertDeathplace({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/luogo-decesso');
      });
    },
    [insertDeathplace, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonDeathplaceCrumbs, { name: 'Nuovo luogo decesso' }]} />
      <FormPlace title="Inserimento luogo decesso" onSave={onSubmit} isDeath />
    </Fragment>
  );
};

DeathplaceNewPage.displayName = 'Deathplace new page component';

export default DeathplaceNewPage;
